import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { PulseCircle } from "../../components";
import { Text } from "../../components/Typography";
import { Easement } from "../../types/LandToken";
import { CURRENCY_NAME } from "../../utils/constants";
import { sizing, toReadable } from "../../utils/methods";
import { BasicPlan, EasementRight } from "./Auction";

export type EasementProps = {
  value: Easement;
  number: number;
  activated?: boolean;
  hideBidding?: boolean;
  onClick?(): void;
};

const EasementCard = ({ value, hideBidding, number, activated, onClick }: EasementProps) => {
  return (
    <BasicPlan>
      
      <div>
        <Text medium sx={{ color: "#3d3d3d", alignItems: "center" }}>
          {activated && <PulseCircle />}
          Tier {number + 1} {activated ? "(Active)" : ""}
          {/* {activated && (
            <Text small bold sx={{ ml: 3, gap: 3, color: "success.main", alignItems: "center" }}>
             Activated
            </Text>
          )} */}
        </Text>
        <Text large numeric sx={{ gap: 3 }}>
          {toReadable(value.activationBid)} <Text large>{CURRENCY_NAME}</Text>
        </Text>
      </div>
      <div>
        {/* <Text medium sx={{ color: "#3d3d3d", mb: 6 }}>
          Planssss
        </Text>
        <Text sx={{ fontSize: "16px", borderBottom: "1px dashed #3d3d3d", width: "100%", pb: sizing(6) }}>
          {value?.description}
        </Text> */}

        <div>
          <CollapseBlock title="Plan" content={value.description} benefits={value.perks} />
        </div>


        {/* {value?.perks?.length ? (
          <Text medium sx={{ color: "#3d3d3d", marginY: 6 }}>
            Benefits
          </Text>
        ) : (
          ""
        )}
        {value?.perks?.length ? (
          <>
            {value.perks.map((a, index) => (
              <EasementRight key={index}>{a}</EasementRight>
            ))}
          </>
        ) : (
          ""
        )} */}

        {/* {value?.perks?.length ? (
          <>
            <Divider
              sx={{
                borderStyle: 'dashed',
                my: 2 // margin top and bottom
              }}
            />
            <CollapseBlock title="Benefits" content={value.perks.map((a, index) => (
              <EasementRight key={index}>{a}</EasementRight>
            ))} />
          </>
        ) : (
          ""
        )} */}

      </div>
      {!hideBidding && !activated && <div />}
      {!hideBidding && !activated && (
        <Button
          onClick={onClick}
          sx={{ width: "150px", color: ({ palette }) => palette.text.secondary, m: sizing(0), mt: sizing(6) }}
        >
          Place bid
        </Button>
      )}
    </BasicPlan>
  );
};

type CollapseBlockProps = {
  title: string;
  content: any;
  benefits?: any;
};
const CollapseBlock = ({ title, content, benefits }: CollapseBlockProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [expanded, setExpanded] = React.useState(!isSmallScreen);

  // Update expansion state when screen size changes
  useEffect(() => {
    setExpanded(!isSmallScreen);
  }, [isSmallScreen]);
  return (
    <Grid width="100%" flexDirection="column" sx={{ background: "#dbdbdb" }}>
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        sx={{
          boxShadow: 'none',
          borderRadius: 0,

        }}
      >

        
        <AccordionSummary
          expandIcon={isSmallScreen && title !== "Benefits" ? <ExpandMoreIcon /> : null}
          aria-controls="panel1d-content"
          id="panel1d-header11"
          sx={{ paddingY: sizing(1), background: "#dbdbdb" }}
        >
          <Text sx={{ fontSize: "16px", color: "#6a6a6a" }} medium>{title}</Text>
        </AccordionSummary>
        <AccordionDetails sx={{ background: "#dbdbdb", paddingBottom: '24px' }}>
          <Text medium sx={{ display: "block" }}>
            {content}
          </Text>
        </AccordionDetails>
      </Accordion>
      {benefits?.length ? (
        <>
         

          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            sx={{
              boxShadow: 'none',
              borderRadius: 0,
              '&::before': {
                display: 'none'
              }
            }}
          >
            <AccordionSummary
              // expandIcon={title !== "Benefits" ? <ExpandMoreIcon /> : null}
              aria-controls="panel1d-content"
              id="panel1d-header11"
              sx={{ paddingY: sizing(1), background: "#dbdbdb" }}
            >
              <Text sx={{ fontSize: "16px", color: "#6a6a6a" }} medium>Benefits</Text>
            </AccordionSummary>

            <AccordionDetails sx={{ background: "#dbdbdb", paddingBottom: '24px' }}>
              {benefits.map((a: any, index: any) => (
                <EasementRight key={index}>{a}</EasementRight>
              ))}
            </AccordionDetails>
          </Accordion>
        </>
      ) : (
        ""
      )}
    </Grid>
  );
};


export default EasementCard;
